import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';

const ErrorOutline = (): JSX.Element => <ErrorOutlineIcon fontSize="inherit" />;

export default ErrorOutline;
